import { useCallback } from 'react';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackNavigationEventData } from './legacy-types';

interface TrackLegacyNavigationOptions {
  from?: string;
  path: string;
}

export const createLegacyTrackNavigation = (
  options: TrackLegacyNavigationOptions,
): LegacyTrackNavigationEventData => {
  const eventData: LegacyTrackNavigationEventData = {
    eventType: 'navigation',
    information: {
      from: options.from,
      path: options.path,
    },
  };

  return eventData;
};

export const useLegacyTrackNavigation = () => {
  const { track } = useLegacyTracking();

  const trackLegacyNavigation = useCallback(
    (options: TrackLegacyNavigationOptions) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'navigation',
        data: createLegacyTrackNavigation(options),
      });
    },
    [track],
  );

  return {
    trackLegacyNavigation,
  };
};
